import '../../../../vendor/js-data/dist/js-data.js';
import '../../../../vendor/js-data-angular/dist/js-data-angular.js';

export const jsDataModule = 'js-data';
